// extracted by mini-css-extract-plugin
export default {"Cards":"style_Cards__XJOXQ","card":"style_card__NTE4i","titleWrap":"style_titleWrap__7yNT9","btn":"style_btn__ZjFAW"};